import React, { Component } from "react";
import { POST, loading, token } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png"
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_view: "password",
      remember: false
    };
  }
  componentDidMount() {
    loading(false);
  }
  Login = async () => {
    loading(true);
    let result = await POST("login", {
      email: this.state.email,
      password: this.state.password,
      remember: this.state.remember,
    });
    if (result?.status) { 
      localStorage.setItem("scp-acc-tk", btoa("Bearer " + result.data.token));
      localStorage.setItem("scp-profile", JSON.stringify({...result.data, password: ""}));
      window.location.href = "/dashboard";
    }
    loading(false);
  };
  render() {
    return (
      <div className="w-100 min-vh-100 background">
        <div className="row">
          <div className="col-12 d-flex align-items-center justify-content-center d-md-none bg-primary py-3">
          <img alt="logo" src={LOGO} className="w-75" style={{minWidth:350}}/>
          </div>
          <div className="col-6 d-none d-md-flex align-items-center justify-content-center bg-primary min-vh-100">
            <img alt="logo" src={LOGO} style={{width: "60%", minWidth:400}}/>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-7 col-xl-6 mx-auto my-5">
            <h3 className="fw-bold text-dark mb-3">เข้าสู่ระบบ</h3>
            <div className="mb-3"><small>กรุณากรอกชื่อผู้ใช้และรหัสผ่านเพื่อเข้าสู่ระบบ</small></div>
            <label className="mb-1">ชื่อผู้ใช้</label>
            <input className="form-control mb-3" type="text" placeholder="ชื่อผู้ใช้" onChange={(e) => { this.setState({ email: e.target.value }); }} value={this.state.email}/>
            <label className="mb-1">รหัสผ่าน</label>
            <div className="position-relative">
              <input className="form-control mb-3" type={this.state.password_view} placeholder="รหัสผ่าน" onChange={(e) => { this.setState({ password: e.target.value });}} onKeyUp={(e) => { if (e.key === "Enter") { this.Login(); } }} value={this.state.password}/>
              <div className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute" style={{right:0, top:1}} onClick={() => {this.setState({password_view: this.state.password_view === "password" ? "text" : "password"})}}>{this.state.password_view === "password" ? "\uf06e" : "\uf070"}</div>
            </div>
            <button type="button" className="btn btn-primary w-100 mb-3" onClick={() => { this.Login(); }}>เข้าสู่ระบบ</button>
            <div className="w-100 text-center">
              <small className="text-secondary text-center">Copyright © 2024 SKCM version {process.env.REACT_APP_VERSION}</small>
            </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
